import http from '@/utils/request';
import { API_BASE } from '@/config/index';

// 查看码单
export function getManageRuleInfo() {
  const url = `${API_BASE.base}/points-server/points/manage/content`;
  return http.get({
    url,
    loading: true,
  });
}
